import { useState, useEffect } from "react";

import Hero from "./Hero/Hero";
import Landing from "./Landing/Landing";

import LoadingScreen from "Components/RequestHandler/LoadingScreen";
import IsError from "Components/RequestHandler/IsError";
import useFetch from "Hooks/useFetch.js";
const ProjectsMainPage = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData("projects");
      console.log("Fetched data:", data);
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const [selectedCat, setSelectedCat] = useState(null);

  const selectedCatHandler = (cat) => {
    // Toggle the category if clicked again
    setSelectedCat((prevCat) => (prevCat === cat ? null : cat));
  };

  // Filter projects based on selected category or show all, and maintain original order
  const filteredProjects = data?.data
    ? selectedCat
      ? data.data.filter((project) => project.category === selectedCat)
      : data.data
    : [];

  // Ensure the projects are sorted in the correct order
  const sortedProjects = filteredProjects.sort((a, b) => a.id - b.id);

  if (isLoading) return <LoadingScreen />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main>
        <Hero
          data={data?.data}
          onHandleSelectedCat={selectedCatHandler}
          selectedCat={selectedCat}
        />
        <Landing projects={sortedProjects} />
      </main>
    );
  }
};

export default ProjectsMainPage;
